import { Button, Col, Form, Input } from "antd";
import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Logo from "../../../src/assets/images/PoweredNew.png";
import userServiceApi from "../../api/userServiceApi";
// import leftArrow from "../../../src/assets/images/LeftArrow.svg";
import backBtn from "../../assets/images/back-arrow.svg";

export default function ResetPasswordForm() {
  const param = useParams();

  const token = param.token;

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const textInput = useRef(null);
  const [form] = Form.useForm();

  const handleReset = async (values) => {
    if (values && values.newPassword && values.confirmPassword) {
      setLoading(true);
      if (values.newPassword !== values.confirmPassword) {
        toast.error("Passwords does not match");
      } else {
        try {
          const response = await fetch(userServiceApi.resetPassword(token), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ newPassword: values.newPassword }),
          });
          if (response.ok) {
            navigate("/admin", { replace: true });
            setLoading(false);
          }
          else {
            const res = await response.json()
            toast.error(res.message)
          }

        } catch (error) {
          console.log('Error in reset password:', error)
          toast.error(error.message)
        }
        finally {
          setLoading(false);
        }
      }
    }
  };

  return (
    <React.Fragment>
      <div className="changepassword-page">
        <div className="header-left" onClick={() => navigate("/")}>
          <img src={backBtn} alt="back-button" />
          <p>Reset password</p>
        </div>

        {/* Form container */}
        <div className="changePwdContainer">
          <Form
            name="control-hooks"
            className="organizationForm"
            form={form}
            autoComplete="off"
            onFinish={handleReset}
          >

            <Form.Item
              name="newPassword"
              label="New Password"
              hasFeedback
              rules={[
                { required: true, message: 'Please input your new password!' },
                { min: 8, message: 'Password must be at least 8 characters long!' },
                {
                  pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                  message: 'Password must include uppercase, lowercase, number, and special character!',
                },
              ]}
            >
              <Input.Password required={true} type="password" placeholder="New Password" />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirm Password"
              dependencies={['newPassword']}  // Add dependencies to revalidate when 'newPassword' changes
              hasFeedback  // Provides feedback to the user as they type
              rules={[
                { required: true, message: 'Please input your new password!' },
                // { min: 8, message: 'Password must be at least 8 characters long!' },
                // {
                //   pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                //   message: 'Passwords do not match',
                // },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Passwords do not match'));
                  },
                }),
              ]}
            >
              <Input.Password required={true} type="password" placeholder="Confirm Password" allowClear />
            </Form.Item>
            <Form.Item label=" " colon={false} >
              <div className="form-btn-container" >
                <Button type="primary" className="redBtn" loading={loading} onClick={() => { form.submit() }}>
                  Update
                </Button>
              </div>
            </Form.Item>

          </Form>
        </div>
        <div className="footerlogo" >
          <div onClick={() => window.open("https://www.connectsu.co.uk/", '_blank')} style={{ cursor: "pointer" }}>
            <img src={Logo} alt="powered-logo" />
          </div>
        </div>
      </div>


    </React.Fragment>
    // <React.Fragment>
    //   {/* <Banner /> */}
    //   <div className="headerBannerRow">
    //     <div className="headerBannerCol">
    //       <div>
    //         <img
    //           className="Reset-headerLogo"
    //           src={Logo}
    //           alt=""
    //           onClick={() => {
    //             navigate("/");
    //           }}
    //         />
    //       </div>
    //     </div>
    //   </div>
    //   <div style={{ padding: '20px' }}>
    //     <div className="header-container">
    //       <div className="partner-header">
    //         <div
    //           className="heading-backBtn"
    //           style={{ cursor: 'pointer' }}
    //           onClick={() => {
    //             navigate("/SuperAdmin");
    //           }}
    //         >
    //           <img src={leftArrow} alt="leftarrow" />
    //           <p style={{ padding: '6px', fontSize: '20px' }}>Reset password</p>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="tabContainer">
    //       <Form
    //         name="control-hooks"
    //         className="organizationForm"
    //         labelCol={{
    //           span: 6,
    //         }}
    //         wrapperCol={{
    //           span: 10,
    //         }}
    //         form={form}
    //         autoComplete="off"
    //         onFinish={handleReset}
    //       >

    //         <Col className="gutter-row" span={15}>
    //           <Form.Item
    //             name="newPassword"
    //             label="New Password"
    //             hasFeedback
    //             rules={[
    //               { required: true, message: 'Please input your new password!' },
    //               { min: 8, message: 'Password must be at least 8 characters long!' },
    //               {
    //                 pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
    //                 message: 'Password must include uppercase, lowercase, number, and special character!',
    //               },
    //             ]}
    //           >
    //             <Input.Password required={true} type="password" placeholder="New Password" />
    //           </Form.Item>
    //         </Col>
    //         <Col className="gutter-row" span={15}>
    //           <Form.Item
    //             name="confirmPassword"
    //             label="Confirm Password"
    //             dependencies={['newPassword']}  // Add dependencies to revalidate when 'newPassword' changes
    //             hasFeedback  // Provides feedback to the user as they type
    //             rules={[
    //               { required: true, message: 'Please input your new password!' },
    //               { min: 8, message: 'Password must be at least 8 characters long!' },
    //               {
    //                 pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
    //                 message: 'Password must include uppercase, lowercase, number, and special character!',
    //               },
    //               ({ getFieldValue }) => ({
    //                 validator(_, value) {
    //                   if (!value || getFieldValue('newPassword') === value) {
    //                     return Promise.resolve();
    //                   }
    //                   return Promise.reject(new Error('Passwords do not match!'));
    //                 },
    //               }),
    //             ]}
    //           >
    //             <Input.Password required={true} type="password" placeholder="Confirm Password" allowClear/>
    //           </Form.Item>
    //         </Col>
    //         <Col className="gutter-row" span={15}>
    //           <Form.Item label=" " colon={false} >
    //             <div className="form-btn-container" >
    //               <Button type="primary" className="redBtn" loading={loading} onClick={() => { form.submit() }}>
    //                 Submit
    //               </Button>
    //             </div>
    //           </Form.Item>
    //         </Col>

    //       </Form>
    //       <div className="footer d-flex" style={{ paddingTop: "2vh" }}>
    //         <div className="footer-content" onClick={() => window.open("https://www.connectsu.co.uk/", '_blank')} style={{ cursor: "pointer" }}>
    //           {/* <span>Powered by</span> */}
    //           <div className="footer-logo">
    //             <img
    //               src={Logo}
    //               alt="company logo"
    //             />
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </React.Fragment>
  );
}
